import React from 'react'


const Loading: React.FC = () => {
    return <div className='loading'>
        Loading...
    </div>
}

export default Loading